import { parseFieldId } from '~/features/fields/isLegacyPilotFieldId';
import { PromptModel } from '~/features/x-ray/types/deprecated';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { PromptModel as PromptModelResponse } from '../../types/sylvanus/model';

interface Request {
  modelId: Uuid;
  includeLatestVersion?: boolean;
}

const getLatestVersion = (response: PromptModelResponse) => {
  const versionNumbers = response.version_numbers ?? [];
  const latestVersionNumber = versionNumbers[versionNumbers.length - 1];
  if (latestVersionNumber == null) {
    return undefined;
  }
  return (
    response.versions?.[latestVersionNumber] ??
    response.versions?.[String(latestVersionNumber)]
  );
};

const getPromptModelDisplayName = (response: PromptModelResponse) => {
  const config = getLatestVersion(response)?.config;
  if (!config) {
    return undefined;
  }
  if (config.prompt_model_type === 'table_extraction') {
    const tableName = config.table_spec?.name;
    return typeof tableName === 'string' && tableName ? tableName : undefined;
  }
  const fieldName = config.field_name;
  return typeof fieldName === 'string' && fieldName ? fieldName : undefined;
};

export const getPromptModel = async ({
  modelId,
  includeLatestVersion,
}: Request): Promise<PromptModel> => {
  const response: PromptModelResponse = await sylvanus.get(
    `/model/${modelId}`,
    {
      params: includeLatestVersion
        ? { include_latest_version: true }
        : undefined,
    },
  );

  return {
    currentOptimizeInfo: response.current_optimize
      ? {
          id: response.current_optimize.optimize_run_id,
          state: response.current_optimize.state,
          testCaseCount: response.current_optimize.total_test_cases ?? 0,
          version: response.current_optimize.version_number,
        }
      : null,
    id: response.id,
    versions: response.version_numbers ?? [],
    fieldId: parseFieldId(response.target_entity.id),
    targetEntityUfId: response.target_entity.uf_id,
    name: getPromptModelDisplayName(response),
    publishStatus: response.current_publish?.status,
    currentPublished: response.current_publish ?? null,
  };
};
